import React, { Component } from "react";
import "./style.css";
class CommonTip extends Component {
  render() {
    const { msg } = this.props;
    return (
      <div className="common_tip">
        <div className="common_tip_text">
          <div
            style={{ height: "50px" }}
            dangerouslySetInnerHTML={{ __html: msg }}
          ></div>
          <div
            onClick={() => this.props.handCloseCommonTip()}
            className="common_error_btn"
          >
            确定
          </div>
        </div>
      </div>
    );
  }
}

export default CommonTip;



// WEBPACK FOOTER //
// ./src/components/CommonTip/index.js